import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from "react";

import Navbar from "../../components/Navbar";
import PageContent from "../../components/PageContent";
import Header from "../../components/Header";

import { useNavigate, useLocation } from "react-router-dom";

import CustomModal from "../../components/CustomModal";
import Banner from "../../components/Banner";

import * as Material from "@mui/material";

import { createTheme, ThemeProvider } from "@mui/material/styles";

import api from "../../helpers/api.js";

import Config, { token } from "../../config.js";

import "./styles.css";

import { ReactComponent as BoletoIcon } from "../../assets/custom-icons/barcode.svg";
import { ReactComponent as BuildProductDraw } from "../../assets/draws/product-creation.svg";
import AddIcon from "@mui/icons-material/Add";

import CheckIcon from "@mui/icons-material/Check";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import SendIcon from "@mui/icons-material/Send";
import EditIcon from "@mui/icons-material/Edit";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import PixIcon from "@mui/icons-material/Pix";
import PaymentIcon from "@mui/icons-material/Payment";
import InsertLinkIcon from "@mui/icons-material/InsertLink";
import SettingsIcon from "@mui/icons-material/Settings";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import ReplayIcon from "@mui/icons-material/Replay";

import { BarChart, barElementClasses } from "@mui/x-charts/BarChart";
import { PieChart } from "@mui/x-charts/PieChart";
import { ResponsiveChartContainer } from "@mui/x-charts/ResponsiveChartContainer";
import { useDrawingArea } from "@mui/x-charts/hooks";

import dayjs, { Dayjs } from "dayjs";

import networkGif from "../../assets/animations/network.gif";

import Feed from "../../components/Feed";

import ReactCrop, {
  centerCrop,
  makeAspectCrop,
  Crop,
  PixelCrop,
  convertToPixelCrop,
} from "react-image-crop";

import "react-image-crop/dist/ReactCrop.css";

import Stack from "@mui/material/Stack";
import Slider from "@mui/material/Slider";

import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import { styled } from "@mui/material/styles";

import Screen from "../../components/Screen";

import MainButton from "../../components/SmallComponents/MainButton";

import {
  useChallenge,
  ChallengeConfigModal,
} from "../../contexts/ChallengeContext";

export default function Communities() {
  document.title = "Comunidades | Ginastee";

  const [communityDetailsModal, setCommunityDetailsModal] = useState({
    open: false,
    mode: "creation", //creation, update
  });

  const { setLoading } = useChallenge();

  window.communities = {};

  function handleOpenCreateNewCommunity() {
    setCommunityDetailsModal({
      open: true,
      mode: "creation",
    });
  }
  function handleConfigureCommunity(communityInfo) {
    setCommunityDetailsModal({
      open: true,
      mode: "update",
      details: communityInfo,
    });
  }

  function handleCreated(productId) {
    setLoading(true);
    handleCloseCommunityDetails();
  }

  function handleCloseCommunityDetails() {
    setCommunityDetailsModal({
      open: false,
      details: null,
      mode: "creation",
    });
  }

  const MEMO_CommunityList = useMemo(
    () => (
      <CommunityList
        handleConfigureCommunity={handleConfigureCommunity}
        handleCreateCommunity={handleOpenCreateNewCommunity}
      />
    ),
    []
  );

  return (
    <>
      <Screen title="Comunidades">
        <main className="communities-screen pb-8">
          <div className="communities-side">
            <h4 className="mt-1" style={{ maxWidth: "580px" }}>
              Crie sua própria comunidade, compartilhe nas redes sociais e
              engaje sua audiência
            </h4>

            <div className="add-new-community-container mt-5">
              <h3>Suas comunidades</h3>

              <MainButton
                shadow={false}
                variant="contained"
                color="white"
                onClick={handleOpenCreateNewCommunity}
                endIcon={<AddIcon />}
                label={"Criar novo comunidade"}
              />
            </div>

            {MEMO_CommunityList}
          </div>

          <Feed />
        </main>
      </Screen>
      <ChallengeConfigModal
        open={communityDetailsModal?.open}
        onClose={handleCloseCommunityDetails}
        onCreated={handleCreated}
        details={communityDetailsModal?.details}
        mode={communityDetailsModal.mode}
      />
    </>
  );
}

function CommunityList({ handleConfigureCommunity, handleCreateCommunity }) {
  const {
    loading,
    setLoading,

    challenges,
    currentChallenge,
  } = useChallenge();

  console.log(challenges);

  function handleOpenUsers(challenge_id) {
    window.navigate("/", {
      state: {
        filterUsers: {
          challenge_id: [challenge_id],
        },
      },
    });
  }
  function handleCopyShareLink(community) {
    const url = community.invite_url;
    navigator.clipboard.writeText(url);
    window.setSnackbar("Link copiado com sucesso");
  }

  const Community = ({ data = {} }) => {
    const { insights } = data;

    const RedirectButton = ({
      disabled = false,
      tooltip,
      text,
      handleRedirect,
    }) => {
      return (
        <Material.Tooltip arrow title={disabled ? null : tooltip}>
          <button
            disabled={disabled}
            className="filter-users-btn"
            onClick={handleRedirect}
          >
            <h5>{text}</h5>
            <Material.IconButton size="small">
              <KeyboardArrowRightIcon color="primary" />
            </Material.IconButton>
          </button>
        </Material.Tooltip>
      );
    };

    return (
      <div className="community-row mb-3 ">
        <div className="pl-2  header-info">
          {loading ? (
            <Material.Skeleton
              className="title mr-4"
              variant="rectangular"
              width={270}
              height={12}
            />
          ) : (
            <h4 className="px-1 title">{data.name}</h4>
          )}

          {loading ? (
            <>
              <Material.Skeleton
                variant="rounded"
                className="mr-2"
                width={120}
                height={34}
              />
              <Material.Skeleton
                variant="rounded"
                className="mr-2"
                width={80}
                height={34}
              />
            </>
          ) : (
            <>
              <MainButton
                disabled={loading}
                shadow={false}
                variant="contained"
                color="white"
                onClick={() => handleConfigureCommunity(data)}
                endIcon={<SettingsIcon />}
                label={"Configurar"}
              />
            </>
          )}
        </div>
        <Material.Divider />
        <div className="px-2 py-1 community-info">
          {loading ? (
            <Material.Skeleton variant="rounded" width={80} height={80} />
          ) : (
            <>
              {data.banner ? (
                <img src={data.banner} className="community-banner" />
              ) : (
                <div className="community-banner"></div>
              )}
            </>
          )}

          <div className="community-customers">
            {loading ? (
              <Material.Skeleton variant="rounded" width={130} height={30} />
            ) : (
              <RedirectButton
                tooltip="Ver membros"
                text={"Membros ativos: " + (data.members || 0)}
                handleRedirect={() => {
                  handleOpenUsers(data.challenge_id);
                }}
              />
            )}

            <Material.Divider orientation="vertical" flexItem />

            <MainButton
              disabled={loading}
              shadow={false}
              variant="contained"
              color="white"
              onClick={() => handleCopyShareLink(data)}
              endIcon={<ContentCopyIcon />}
              label={"Copiar link de compatilhamento"}
            />
          </div>
        </div>
      </div>
    );
  };
  const NoCommunities = ({}) => {
    return (
      <div className="no-communities-box px-4 py-1">
        <BuildProductDraw className="no-communities-draw" />
        <div>
          <h3>Crie sua primeira comunidade</h3>
          <h5 className="pb-2">
            Adicione suas comunidades para engajar com sua audiência
          </h5>
          <MainButton
            shadow={false}
            variant="contained"
            color="primary"
            onClick={handleCreateCommunity}
            endIcon={<AddIcon />}
            label={"Criar nova comunidade"}
          />
        </div>
      </div>
    );
  };

  const communitiesDisplay = loading ? [{}, {}, {}, {}] : challenges;

  return (
    <div className="mt-3">
      {communitiesDisplay.map((item, index) => (
        <Community data={item} key={index} />
      ))}
      {!loading && !challenges.length && <NoCommunities />}
    </div>
  );
}
